var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHvac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 42.28",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "heating"
  }, "Heating and Air Conditioning Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "heating"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.45,28.85V15.45a3.46,3.46,0,0,0-3.4-3.5h-.2a3.46,3.46,0,0,0-3.4,3.5v11.2H19V15.45a2.08,2.08,0,0,1,1.9-2.1h.2a2,2,0,0,1,1.9,2.1v14.2h.2l.1.1a4.36,4.36,0,0,1,1.8,3.5,4.4,4.4,0,1,1-6.4-3.9.74.74,0,0,0-.7-1.3,5.81,5.81,0,1,0,8.4,5.2A5.15,5.15,0,0,0,24.45,28.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.45,26.85h-6.1a.7.7,0,1,0,0,1.4h6.1a.7.7,0,1,0,0-1.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15,21v9.8a2.58,2.58,0,0,0-1.9,2.5,2.6,2.6,0,0,0,5.2,0,2.58,2.58,0,0,0-1.9-2.5V21Zm1.9,12.3a1.2,1.2,0,0,1-2.4,0,1.2,1.2,0,1,1,2.4,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.35,23.75h-8a.7.7,0,1,0,0,1.4h8a.7.7,0,1,0,0-1.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.45,15.75a.7.7,0,0,0,0-1.4h-6.1a.68.68,0,0,0-.7.7c-.1.4.3.7.7.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.35,17.45h-8a.7.7,0,1,0,0,1.4h8a.7.7,0,1,0,0-1.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.35,22.05h6.1a.7.7,0,0,0,0-1.4h-6.1a.7.7,0,1,0,0,1.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.38,13.58,24.38.08l-.08,0-.13,0h-.24l-.14,0-.07,0L.62,13.58a.67.67,0,0,0-.24.9.68.68,0,0,0,.57.33.66.66,0,0,0,.33-.09l2.81-1.65V41.15a.66.66,0,1,0,1.32,0V12.3L24.05,1.41,42.59,12.29V41.15a.66.66,0,1,0,1.32,0V13.06l2.81,1.65a.58.58,0,0,0,.33.1.66.66,0,0,0,.33-1.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvac);
export default __webpack_public_path__ + "static/media/hvac.a7998c750d58ee60e4624a75cbb6e469.svg";
export { ForwardRef as ReactComponent };